module.exports = __webpack_public_path__ + "static/media/help-rule-1.1df9e923.gif";